module.exports = __webpack_public_path__ + "img/ico_send.869d181b.png";